var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary darken-2"}}):_vm._e(),_c('v-main',[_c('router-view')],1),_c('Ribbon'),_c('Modal2FA')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }